var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-container",
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-card",
                [
                  _c("w-card-title", [_vm._v("New Module")]),
                  _c(
                    "w-card-content",
                    [_c("edit-module", { attrs: { module: _vm.module } })],
                    1
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.save()
                            },
                          },
                        },
                        [_vm._v(" Save ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }